import { useRef, useEffect, useState } from "react";
import { apiWithInterceptor } from "../../../../api";

// UI Elements
import {
  Card,
  Text,
  Grid,
  List,
  Box,
  Accordion,
  UnstyledButton,
  useMantineTheme,
  ActionIcon,
  CloseButton,
  TextInput,
  Button,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconPlus, IconMenu2 } from "@tabler/icons";

// jquery Sortable component

import $ from "jquery";
import "jquery-ui-dist/jquery-ui";

// utils
import PageHeading from "../../../../components/PageHeading";
import FormField from "./FormField";
import AddFieldModal from "./Modals/AddField";
import { useSetState } from "@mantine/hooks";

export default function FormBuilder() {
  const theme = useMantineTheme();
  const fieldsListRef = useRef();
  const sortableInit = useRef(false);
  const [addFieldModalState, setAddFieldModalState] = useState(false);

  // Setting the field object values
  const [fieldsObj, setFieldsObj] = useSetState({
    fields: {},
    ids: [],
  });

  const [formName, setFormname] = useState("");

  // const getFields = () => {
  //   return Object.keys(fieldsObj.fields).map((key) => {
  //     return fieldsObj.fields[key];
  //   });
  // };

  // Render the last fields order after implementing Jquery on the DOM
  const getFieldsOrdered = () => {
    let fields = [];
    fieldsObj.ids.forEach((id) => {
      fields.push(fieldsObj.fields[id]);
    });
    return fields;
  };

  // Set the values that comes form the Field Form component
  const setFieldValues = (id, values) => {
    setFieldsObj({
      fields: {
        ...fieldsObj.fields,
        [id]: {
          ...fieldsObj.fields[id],
          values,
        },
      },
    });
  };

  const addField = (field) => {
    const id = `field_${fieldsObj.ids.length}`;
    const newField = {
      ...field,
      id,
    };
    setFieldsObj({
      fields: {
        [id]: newField,
        ...fieldsObj.fields,
      },
      ids: [...fieldsObj.ids, id],
    });
  };

  const removeField = (id) => {
    delete fieldsObj.fields[id];
    setFieldsObj({
      ids: fieldsObj.ids.filter((fieldId) => fieldId !== id),
    });
  };

  // Set the new order to render in the fields component

  const setFieldsOrder = (newOrder) => {
    setFieldsObj({
      ids: newOrder,
    });
  };

  // Sort the new order for the fields

  useEffect(() => {
    if (sortableInit.current) {
      $(fieldsListRef.current).sortable("refresh");
    } else {
      $(fieldsListRef.current).sortable({
        items: ">li",
        stop: (event, ui) => {
          const newOrder = $(fieldsListRef.current).sortable("toArray", {
            attribute: "id",
          });
          setFieldsOrder(newOrder);
        },
      });
      sortableInit.current = true;
    }
  }, [fieldsObj.ids.length]);

  const user = JSON.parse(localStorage.getItem("userInfo"));

  const fields = getFieldsOrdered().map((item) => {
    if (!item.values) return item;
    const values = item.values;
    values.default_value = "";
    values.default_value = item.values.defaultValue;
    delete values.defaultValue;
    return {
      data_type: item.dataType.toUpperCase(),
      presentation: item.presentation.toUpperCase(),
      ...values,
    };
  });
  const handelSubmit = (e) => {
    e.preventDefault();
    apiWithInterceptor
      .post("/form", {
        fields: fields,
        name: formName,
        user_id: user.id,
      })
      .then(function (response) {
        showNotification({
          title: `${response?.request?.statusText}`,
          message: "Form Successfuly created",
          color: "green",
        });
        setFieldsObj({
          fields: {},
          ids: [],
        });
        setFormname("");
      })
      .catch(function (error) {
        console.log(error);
        showNotification({
          title: "Failed to create a new form",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  };

  return (
    <form
      onSubmit={(e) => {
        handelSubmit(e);
      }}
    >
      <PageHeading>New Form</PageHeading>
      <Grid mb={"xs"}>
        <Grid.Col span={12}>
          <TextInput
            onChange={(e) => setFormname(e.target.value)}
            placeholder="Form Name"
          />
        </Grid.Col>
      </Grid>
      <Text size={"sm"} mb={"xs"}>
        Fields
      </Text>
      <Card
        p={0}
        sx={{
          background: "transparent",
          overflow: "visible",
        }}
      >
        <List
          id="fields-list"
          ref={fieldsListRef}
          mb={"sm"}
          sx={{
            listStyle: "none",
            "&>*:not(last-child)": {
              marginBottom: "20px",
            },
          }}
        >
          {Object.keys(fieldsObj.fields)
            .map((id) => fieldsObj.fields[id])
            .reverse()
            .map((field) => (
              <List.Item
                id={field.id}
                key={field.id}
                sx={{ "& > *": { width: "100%" } }}
              >
                <Card withBorder p={0} sx={{ overflow: "visible" }}>
                  <Accordion chevronPosition="right" m={0} pl={"sm"} pr={"md"}>
                    <Accordion.Item value={field.label} sx={{ border: 0 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            cursor: "move",
                          }}
                        >
                          <IconMenu2 size={16} />
                        </Box>
                        <Accordion.Control py={15}>
                          <Text>{field.label}</Text>
                          <Text size="sm" color="dimmed" weight={400}>
                            {field.type}
                          </Text>
                        </Accordion.Control>
                        <ActionIcon size="lg">
                          <CloseButton
                            size="md"
                            onClick={() => removeField(field.id)}
                          />
                        </ActionIcon>
                      </Box>
                      <Accordion.Panel>
                        <FormField
                          field={field}
                          setFieldValues={setFieldValues}
                        />
                      </Accordion.Panel>
                    </Accordion.Item>
                  </Accordion>
                </Card>
              </List.Item>
            ))}
        </List>
        <UnstyledButton
          sx={{ width: "100%" }}
          onClick={() => {
            setAddFieldModalState(true);
          }}
        >
          <Card
            withBorder
            py={30}
            sx={{
              transition: ".3s",
              "&:hover": {
                borderColor: theme.colors.brand[4],
                backgroundColor: `${theme.colors.brand[9]}02`,
              },
              "&:hover *": {
                color: theme.colors.brand[5],
              },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <IconPlus />

              <Text ml={"xs"}>Add Field</Text>
            </Grid>
          </Card>
        </UnstyledButton>
      </Card>
      <Button mt={"lg"} type="submit">
        Create Form
      </Button>
      <AddFieldModal
        opened={addFieldModalState}
        onClose={() => {
          setAddFieldModalState(false);
        }}
        onFieldClick={(field) => {
          addField(field);
          setAddFieldModalState(false);
        }}
      />
    </form>
  );
}
